import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { I18nProvider } from "./i18n";
import { CartProvider } from "./cart";
import Home from "./pages/Home";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import CheckoutCancel from "./pages/CheckoutCancel";

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <CartProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/checkout/success" element={<CheckoutSuccess />} />
              <Route path="/checkout/cancel" element={<CheckoutCancel />} />
            </Routes>
            <Toaster
              position="bottom-right"
              theme="light"
              toastOptions={{
                style: {
                  background: "#FFFFFF",
                  border: "1px solid #E5DDD0",
                  color: "#1A1612",
                  fontFamily: "Outfit, sans-serif",
                  letterSpacing: "0.02em",
                },
              }}
            />
          </BrowserRouter>
        </CartProvider>
      </I18nProvider>
    </div>
  );
}

export default App;
